module.exports = __webpack_public_path__ + "bc9e0f32.svg";